function FieldError({ id, message }) {
  if (!message) {
    return null;
  }

  return (
    <p className="form-error" id={id}>
      {message}
    </p>
  );
}

export default FieldError;